export const HS_INTERNAL_USER_ID = 'hs_internal_user_id';
export const HS_INVITE_STATUS = 'hs_invite_status';
export const HS_MANAGER = 'hs_manager';
export const HS_STANDARD_TIME_ZONE = 'hs_standard_time_zone';
export const HS_TIMEZONE_AUTO_UPDATE_ENABLED = 'hs_timezone_auto_update_enabled';
export const USER_OBJECT_TYPE_ID = '0-115';